import Vue from 'vue';
import Router, { RouterMode, RawLocation } from 'vue-router';
import store from '@/store';
import AppRoutes from './app';
import Settings from './settings';
import auth_required from '@/routes/hooks/auth_required';
import authorized from '@/routes/hooks/authorized';
import login_external from '@/routes/hooks/login-external';
import api from '@/services/utils/base';
// @ts-ignore
import NotFoundPage from '@/views/pages/404.vue';
// @ts-ignore
import LoginForm from '@/views/pages/login.vue';
// @ts-ignore
import LoginMemberForm from '@/views/pages/login-member.vue';
// @ts-ignore
import LoginSupportForm from '@/views/pages/login-support.vue';
// @ts-ignore
import RegisterForm from '@/views/pages/register.vue';
// @ts-ignore
import TwoFactor from '@/views/pages/two-factor/two-factor.vue';
// @ts-ignore
import ForgotPasswordForm from '@/views/pages/forgot-password.vue';
import {ErrorHandler, VueRouter,Route} from 'vue-router/types/router';

import multiguard from 'vue-router-multiguard';

import desktopViewForced from '@/routes/hooks/desktop-view-forced';
import registerCurrency from '@/routes/hooks/register-currency';
import registerEmailVerification from '@/routes/hooks/register-email-verification';
import app from '@/main';

function genRouterFunc(originalFunc: (location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler) => void | Promise<Router>) {
  return function push(this: Router, location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler): any {
    // console.trace('push', originalFunc, location);
    // //@ts-ignore
    // if(location.params && location.params.data) {
    //   //@ts-ignore
    //   console.log(query.decode(location.params.data));
    // }

    const result = originalFunc.call(this, location, onComplete, onAbort);
    return result 
      ? result.catch((err: any) => {
        if(err && err.name !== 'NavigationDuplicated') {
          console.error(err);
          return Promise.reject(err);
        } 
      })
      : result;
  }
}

const originalPush = Router.prototype.push;
Router.prototype.push = genRouterFunc(originalPush);

const originalReplace = Router.prototype.replace;
Router.prototype.replace = genRouterFunc(originalReplace);

Vue.use(Router);

export interface AppRouter extends VueRouter {
  getPageTitle(route?: Route): string
}

const router = new Router({
  mode: process.env.VUE_APP_CONFIG_ROUTING_MODE as RouterMode || 'history',
  base: '/',
  routes: [
    ...AppRoutes,
    ...Settings,
    {
      path: '/',
      name: 'root',
      beforeEnter: multiguard([auth_required, desktopViewForced]),
      meta: {
        pageTitle: 'Root'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginForm,
      beforeEnter: multiguard([authorized, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login'
      }
    },
    {
      path: '/!/login',
      name: 'login_',
      component: LoginForm,
      beforeEnter: multiguard([authorized, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login_'
      }
    },
    {
      path: '/login/member',
      name: 'login.member',
      component: LoginMemberForm,
      beforeEnter: multiguard([desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login member'
      }
    },
    {
      path: '/login/support',
      name: 'login.support',
      component: LoginSupportForm,
      beforeEnter: multiguard([desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login support'
      }
    },
    {
      path: '/!/login/member',
      name: 'login.member_',
      component: LoginMemberForm,
      beforeEnter: multiguard([desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login member_'
      }
    },
    {
      path: '/two-factor',
      name: 'two-factor',
      component: TwoFactor,
      beforeEnter: multiguard([desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Two factor authentication'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterForm,
      beforeEnter: multiguard([authorized, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Register'
      }
    },
    {
      path: '/register-currency',
      name: 'register-currency',
      component: RegisterForm,
      beforeEnter: multiguard([desktopViewForced, registerCurrency]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Registration step 3'
      }
    },
    {
      path: '/register-email-verification',
      name: 'register-email-verification',
      component: RegisterForm,
      beforeEnter: multiguard([desktopViewForced, registerEmailVerification]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Registration step 2'
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPasswordForm,
      beforeEnter: multiguard([authorized, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Forgot password'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: (to: any, from: any, next: Function) => {
        window.localStorage.removeItem('auth-token');
        window.localStorage.removeItem('http-cache-version');
        window.sessionStorage.removeItem('impersonation');
        store.commit('logout');
        app.$toasted.clear();
        api.removeAuthToken();
        return next('/login');
      },
      meta: {
        pageTitle: 'Logout'
      }
    },
    {
      //http://beta.panel.bemob.com/#/login-external?token=
      path: '/login-external',
      name: 'login.ext',
      beforeEnter: multiguard([login_external, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login external'
      }
    },
    {
      //http://beta.panel.bemob.com/#!/login-external?token=
      path: '/!/login-external',
      name: 'login.ext!',
      beforeEnter: multiguard([login_external, desktopViewForced]),
      meta: {
        ignoreDesktopViewForced: true,
        pageTitle: 'Login external_'
      }
    },
    {
      path: '*',
      component: NotFoundPage,
      meta: {
        pageTitle: 'Not found page'
      }
    }
  ]
});

router.getPageTitle= function (this:VueRouter,route = this.currentRoute){
  if(route.name==='app.report'){
    return `${route.meta.pageTitle} ${route.params.type}`
  }
  return route.meta.pageTitle;
}


const isRouteReallyChanged = (to, from)=>{
  // check report urls
  if(to.name==='app.report' && from.name==='app.report' && to.params.type!==from.params.type) return true;

  // check not report urls
  if(to.name!==from.name) return true;

  return;
}

router.afterEach((to, from) => {
  if(!app?.$mixpanel) return false;

  if(!isRouteReallyChanged(to, from) || !store?.state?.user) return false;

  const {id,lastName='',firstName='', email, currencyId, language, subscriptionPlan} = store?.state?.user;
  const userProperty = {
    ...(email&&{$email:email}),
    ...(currencyId&&{currencyId}),
    ...(language&&{language}),
    ...(subscriptionPlan&&{subscriptionPlan}),
    ...((firstName||lastName) &&{$name: `${firstName} ${lastName}`}),
    ...((firstName) &&{$firstName:firstName}),
    ...((lastName) &&{$lastName:lastName})
  };
  if(Object.keys(userProperty).length !== 0){
    app.$mixpanel?.people.set(userProperty);
    app.$mixpanel?.identify(id);
  }
  app.$mixpanel?.track('Page View',{
    pageTitle:router.getPageTitle(to)
  })

});

export default router